
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/building/[id]/[name]",
      function () {
        return require("private-next-pages/building/[id]/[name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/building/[id]/[name]"])
      });
    }
  